import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

export function ResourceNotFound() {
  const { t } = useTranslation();

  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-background">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="flex justify-center">
          <AlertCircle className="h-24 w-24 text-destructive" />
        </div>
        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">
            {t("resourceNotFound.title")}
          </h1>
          <p className="text-muted-foreground">
            {t("resourceNotFound.description")}
          </p>
        </div>
        <Button onClick={handleBack} size="lg" className="w-full">
          {t("resourceNotFound.backButton")}
        </Button>
      </div>
    </div>
  );
}
